import React from 'react';
import { Link } from 'react-router-dom';
import { GovCard, GovSkeleton } from '@gov-design-system-ce/react';
import { useCmsUsefulLinksQuery } from '@gov-nx/api';
import { useLocale } from '@gov-nx/core/service';
import { PageCode } from '@gov-nx/module/page';
import { CardCarousel, LayoutGap } from '@gov-nx/ui/web';
import { generateRandomNumber } from '@gov-nx/utils/common';
import { pageRouteResolver } from '@gov-nx/web';

export const HomepageLinksSection = () => {
	const code = PageCode['rozcestnik'];
	const { t } = useLocale(code);
	const { data, isLoading, baseCmsUrlPath } = useCmsUsefulLinksQuery();

	return (
		<section aria-labelledby="uzitecne-odkazy">
			<CardCarousel
				headline={t('nadpis.uzitecne-odkazy')}
				headlineId="uzitecne-odkazy"
				showAllButton={t('akce.zobrazit-vse')}
				showAllButtonUrl={pageRouteResolver('uzitecne-odkazy')}
				showAllButtonAria={t('akce.wcag.zobrazit-vse-odkazy')}
				arrowLeftAria={t('akce.posunout-zpet')}
				arrowRightAria={t('akce.posunout-vpred')}>
				{isLoading
					? Array.from({ length: 4 }).map((_, i) => (
							<li
								/* eslint-disable-next-line react/no-array-index-key */
								key={`usefulLinkSkeleton-${i}`}
								className="snap-start flex-[0_0_18.75rem]">
								<GovCard>
									<LayoutGap gap="s">
										<GovSkeleton
											height="42px"
											width="70px"
										/>
										<GovSkeleton
											height="24px"
											className="my-(--templates-margin-s)!"
											width={generateRandomNumber(50, 80) + '%'}
										/>
										<div className="space-y-4">
											<GovSkeleton
												height="14px"
												width="100%"
											/>
											<GovSkeleton
												height="14px"
												width="100%"
											/>
											<GovSkeleton
												height="14px"
												width="100%"
											/>
											<GovSkeleton
												height="14px"
												width="100%"
											/>
											<GovSkeleton
												height="14px"
												width={generateRandomNumber(30, 80) + '%'}
											/>
										</div>
									</LayoutGap>
								</GovCard>
							</li>
						))
					: data.map((usefulLink) => (
							<li
								key={usefulLink.id}
								className="snap-start flex-[0_0_18.75rem]">
								<GovCard asChild>
									<Link
										to={usefulLink.link}
										target="_blank">
										<LayoutGap gap="s">
											<img
												src={baseCmsUrlPath + usefulLink.logo.file}
												alt={usefulLink.title + 'logo'}
												style={{
													height: '48px',
													width: 'min-content',
													objectFit: 'contain',
												}}
											/>
											<h3 className="text-headline-s!">{usefulLink.title}</h3>
											{usefulLink.description && (
												<p className="mt-0!">{usefulLink.description}</p>
											)}
										</LayoutGap>
									</Link>
								</GovCard>
							</li>
						))}
			</CardCarousel>
		</section>
	);
};
